import { render, staticRenderFns } from "./PushNotificationIntergation.vue?vue&type=template&id=6b96fe7e&scoped=true&"
import script from "./PushNotificationIntergation.vue?vue&type=script&lang=js&"
export * from "./PushNotificationIntergation.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationIntergation.vue?vue&type=style&index=0&id=6b96fe7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b96fe7e",
  null
  
)

export default component.exports